module.exports = __webpack_public_path__ + "static/images/dollar-30x48-full.c2a7bbd1ed385913a86bd595361f4548.svg";